var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentLoader,{tag:"component",attrs:{"title":_vm.title,"options":_vm.options,"moduleId":_vm.moduleId,"type":_vm.componentType,"commentsActive":_vm.commentsActive}})}
var staticRenderFns = []

export { render, staticRenderFns }